module.exports = __webpack_public_path__ + "img/type_icon3.f6fb6a7b.png";